import { create } from 'zustand';

import type { DagDetailTabKey } from './types';

type DagDetailTabsState = {
  currentTab: DagDetailTabKey;
  isExpanded: boolean;
  setCurrentTab: (tab: DagDetailTabKey) => void;
  resetExpanded: () => void;
  toggleExpanded: () => void;
  resetTabsState: () => void;
};

export const useDagDetailTabsStore = create<DagDetailTabsState>((set) => ({
  currentTab: 'Task',
  isExpanded: false,
  setCurrentTab: (tab) => set({ currentTab: tab }),
  toggleExpanded: () => set((state) => ({ isExpanded: !state.isExpanded })),
  resetExpanded: () => set({ isExpanded: false }),
  resetTabsState: () => set({ currentTab: 'Task', isExpanded: false }),
}));
